import { useState } from 'react';
import api from '../../api';

const SUGGESTED_EMOJIS = [
  '🍺','🍻','🥂','🍷','🍸','🍹','🥃','🧃','🥤','💧',
  '🍕','🍔','🌭','🥨','🧀','🥓','🍗','🍖','🥚','🧆',
  '🍿','🧂','🥜','🫙','🍫','🍬','🍭','🍪','🎂','🧁',
  '🥔','🥦','🥕','🧅','🌽','🫑','🥒','🍅','🧄','🫒',
  '🐟','🦐','🦑','🦞','🦀','🐙','🥩','🍣','🍱','🫕',
];

export default function CategoryManager({ storeId, categories, onUpdate, network }) {
  const [showForm, setShowForm] = useState(false);
  const [editCat, setEditCat] = useState(null);
  const [form, setForm] = useState({ name:'', photo_url:'', sort_order:0, show_in_pos:true });
  const [error, setError] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  // Мережевий режим (Асортимент) → store-less ендпоінти; інакше — по магазину.
  const catBase = network ? '/catalog/categories' : `/catalog/stores/${storeId}/categories`;

  function openCreate() {
    setEditCat(null);
    setForm({ name:'', photo_url:'', sort_order: categories.length, show_in_pos: true });
    setShowForm(true);
    setError('');
  }

  function openEdit(cat) {
    setEditCat(cat);
    setForm({ name: cat.name, photo_url: cat.photo_url || '', sort_order: cat.sort_order, show_in_pos: cat.show_in_pos !== false });
    setShowForm(true);
    setError('');
  }

  async function handleSubmit(e) {
    e.preventDefault(); setError('');
    try {
      if (editCat) {
        await api.patch(`${catBase}/${editCat.id}`, form);
      } else {
        await api.post(catBase, form);
      }
      await onUpdate();
      setShowForm(false);
    } catch(err) { setError(err.response?.data?.detail || 'Помилка'); }
  }

  async function handleDelete(cat) {
    if (!window.confirm(`Видалити категорію "${cat.name}"? Товари залишаться але без категорії.`)) return;
    await api.delete(`${catBase}/${cat.id}`);
    await onUpdate();
  }

  function selectEmoji(emoji) {
    setForm(f => ({...f, photo_url: emoji}));
    setShowEmojiPicker(false);
  }

  // Перевіряємо чи це emoji (короткий рядок) чи URL
  function renderPreview(photo_url) {
    if (!photo_url) return <span style={styles.noIcon}>?</span>;
    if (photo_url.startsWith('http')) {
      return <img src={photo_url} alt="" style={styles.previewImg} />;
    }
    return <span style={styles.previewEmoji}>{photo_url}</span>;
  }

  return (
    <div style={styles.wrap}>
      <div style={styles.header}>
        <h3 style={styles.title}>📂 Категорії товарів</h3>
        <button style={styles.addBtn} onClick={openCreate}>+ Додати</button>
      </div>

      {/* Форма */}
      {showForm && (
        <div style={styles.form}>
          <form onSubmit={handleSubmit}>
            <div style={styles.formRow}>
              {/* Іконка */}
              <div style={styles.iconSection}>
                <label style={styles.label}>Іконка</label>
                <div style={styles.iconPreview} onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
                  {renderPreview(form.photo_url)}
                </div>
                <div style={styles.iconHint}>Клікніть щоб обрати emoji</div>

                {showEmojiPicker && (
                  <div style={styles.emojiPicker}>
                    <div style={styles.emojiGrid}>
                      {SUGGESTED_EMOJIS.map(e => (
                        <button key={e} type="button" style={styles.emojiBtn}
                          onClick={() => selectEmoji(e)}>
                          {e}
                        </button>
                      ))}
                    </div>
                    <div style={styles.emojiUrlRow}>
                      <input style={styles.emojiUrlInput}
                        placeholder="або вставте URL картинки"
                        value={form.photo_url.startsWith('http') ? form.photo_url : ''}
                        onChange={e => setForm(f => ({...f, photo_url: e.target.value}))} />
                    </div>
                  </div>
                )}
              </div>

              {/* Назва і порядок */}
              <div style={styles.formFields}>
                <div style={styles.fieldGroup}>
                  <label style={styles.label}>Назва категорії</label>
                  <input style={styles.input}
                    placeholder="Наприклад: Розливне пиво"
                    value={form.name}
                    onChange={e => setForm(f => ({...f, name: e.target.value}))}
                    required />
                </div>
                <div style={styles.fieldGroup}>
                  <label style={styles.label}>Порядок відображення</label>
                  <input style={styles.input} type="number" min="0"
                    value={form.sort_order}
                    onChange={e => setForm(f => ({...f, sort_order: parseInt(e.target.value)||0}))} />
                </div>
                <label style={styles.posToggle}>
                  <input type="checkbox" checked={form.show_in_pos}
                    onChange={e => setForm(f => ({...f, show_in_pos: e.target.checked}))} />
                  🖥 Показувати у швидкому меню каси
                </label>
              </div>
            </div>

            {error && <p style={styles.error}>{error}</p>}
            <div style={styles.formBtns}>
              <button type="submit" style={styles.saveBtn}>
                {editCat ? 'Зберегти' : 'Створити'}
              </button>
              <button type="button" style={styles.cancelBtn}
                onClick={() => setShowForm(false)}>
                Скасувати
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Список категорій */}
      {categories.length === 0 ? (
        <p style={styles.empty}>Категорій ще немає — додайте першу!</p>
      ) : (
        <div style={styles.catList}>
          {categories.map(cat => (
            <div key={cat.id} style={styles.catItem}>
              <div style={styles.catIcon}>{renderPreview(cat.photo_url)}</div>
              <div style={styles.catInfo}>
                <div style={styles.catName}>{cat.name}</div>
                <div style={styles.catOrder}>порядок: {cat.sort_order}</div>
              </div>
              <div style={styles.catActions}>
                <button style={styles.editBtn} onClick={() => openEdit(cat)}>✏️</button>
                <button style={styles.deleteBtn} onClick={() => handleDelete(cat)}>🗑</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  wrap: { marginBottom:'24px' },
  header: { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'12px' },
  title: { color:'#f5a623', margin:0, fontSize:'16px' },
  addBtn: { padding:'7px 16px', background:'#f5a623', color:'#14110c', border:'none', borderRadius:'7px', cursor:'pointer', fontWeight:'bold', fontSize:'13px' },
  form: { background:'#1c1812', borderRadius:'10px', padding:'16px', marginBottom:'16px', border:'1px solid #38301f' },
  formRow: { display:'flex', gap:'16px', marginBottom:'12px' },
  iconSection: { flexShrink:0, position:'relative' },
  iconPreview: { width:'64px', height:'64px', background:'#211c14', borderRadius:'12px', border:'2px dashed #38301f', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', fontSize:'32px' },
  previewEmoji: { fontSize:'32px', lineHeight:1 },
  previewImg: { width:'48px', height:'48px', objectFit:'cover', borderRadius:'8px' },
  noIcon: { color:'#9a8a6e', fontSize:'24px' },
  iconHint: { color:'#9a8a6e', fontSize:'10px', textAlign:'center', marginTop:'4px' },
  emojiPicker: { position:'absolute', top:'70px', left:0, background:'#211c14', border:'1px solid #38301f', borderRadius:'10px', padding:'10px', zIndex:100, width:'240px', boxShadow:'0 8px 32px rgba(0,0,0,0.5)' },
  emojiGrid: { display:'grid', gridTemplateColumns:'repeat(8, 1fr)', gap:'4px', marginBottom:'8px' },
  emojiBtn: { background:'transparent', border:'none', cursor:'pointer', fontSize:'20px', padding:'4px', borderRadius:'4px' },
  emojiUrlRow: { borderTop:'1px solid #38301f', paddingTop:'8px' },
  emojiUrlInput: { width:'100%', padding:'6px 8px', borderRadius:'6px', border:'1px solid #38301f', background:'#1c1812', color:'#fff', fontSize:'12px', boxSizing:'border-box' },
  formFields: { flex:1 },
  fieldGroup: { marginBottom:'10px' },
  posToggle: { display:'flex', alignItems:'center', gap:'8px', fontSize:'13px', color:'#f4ead7', cursor:'pointer', marginTop:'4px' },
  label: { display:'block', color:'#9a8a6e', fontSize:'11px', marginBottom:'4px', textTransform:'uppercase' },
  input: { width:'100%', padding:'8px 12px', borderRadius:'7px', border:'1px solid #38301f', background:'#211c14', color:'#fff', fontSize:'14px', boxSizing:'border-box' },
  error: { color:'#ff6b6b', fontSize:'12px', marginBottom:'8px' },
  formBtns: { display:'flex', gap:'8px' },
  saveBtn: { padding:'8px 24px', background:'#f5a623', color:'#14110c', border:'none', borderRadius:'7px', cursor:'pointer', fontWeight:'bold', fontSize:'13px' },
  cancelBtn: { padding:'8px 16px', background:'transparent', color:'#9a8a6e', border:'1px solid #38301f', borderRadius:'7px', cursor:'pointer', fontSize:'13px' },
  empty: { color:'#9a8a6e', textAlign:'center', padding:'16px' },
  catList: { display:'flex', flexDirection:'column', gap:'6px' },
  catItem: { background:'#211c14', borderRadius:'8px', padding:'10px 14px', border:'1px solid #38301f', display:'flex', alignItems:'center', gap:'12px' },
  catIcon: { width:'40px', height:'40px', display:'flex', alignItems:'center', justifyContent:'center', background:'#1c1812', borderRadius:'8px', fontSize:'22px', flexShrink:0 },
  catInfo: { flex:1 },
  catName: { fontWeight:'bold', fontSize:'14px' },
  catOrder: { color:'#9a8a6e', fontSize:'11px' },
  catActions: { display:'flex', gap:'6px' },
  editBtn: { background:'#38301f', border:'none', borderRadius:'6px', padding:'5px 8px', cursor:'pointer', fontSize:'14px' },
  deleteBtn: { background:'rgba(255,107,107,.18)', border:'none', borderRadius:'6px', padding:'5px 8px', cursor:'pointer', fontSize:'14px' },
};
